import React, { useState } from "react";
import "./Table.css";
import { Globals } from "../../global/Globals";
import { formatDate } from "../../util/util";

const NewTable = (props) => {
  const [isAscending, setIsAscending] = useState(true);
  const [sortKey, setSortKey] = useState("");
  console.log("props.dataz",props.data);

  if (!props.data || props.data.length === 0) {
    return <p>No data available</p>;
  }

  console.log("props.dataz",props.data);

  const headers = Object.keys(props.data[0]);

  const handleSort = (event) => {
    event.stopPropagation();
    console.log("props.data", props.data);
    const sortedData = [...props.data].sort((a, b) => {
      const dateA = new Date(a.submissionDate);
      const dateB = new Date(b.submissionDate);
      console.log("dateA-dateB", dateA);
      console.log("dateA-dateB", dateB);
      return isAscending ? dateA - dateB : dateB - dateA;
    });
    setIsAscending(!isAscending);
    props.onSort(sortedData);
  };

  const statusImg = (statusCode) => {
    const Title = Globals.TABLE_STATUS[statusCode];
    console.log("statusImg",Title,statusCode);
    const title = Title.toUpperCase();
    const statusImg = Globals.IMG[title];
    return statusImg;
  };

  const formatStatus = (statusData) => {
    const Title = Globals.TABLE_STATUS[statusData];
    return Title;
  };

  const proposols_type = (type) => {
    const Proposal_Type = Globals.PROPOSALS_TYPE[type];
    return Proposal_Type;
  };

  return (
    <table>
      <thead>
        <tr>
          {headers.map((header) => {
            if (header === "bRefNo") {
              return (
                <th key={header} className="refno">
                  Ref. No
                </th>
              );
            }
            if (header === "BriefNo") {
                return (
                  <th key={header} className="refno">
                    Brief Ref. No
                  </th>
                );
              }
              if (header === "ChannelName") {
                return (
                  <th key={header} className="refno">
                    Channel
                  </th>
                );
              }
              if (header === "CreatedBy") {
                return (
                  <th key={header} className="refno">
                   Created by
                  </th>
                );
              }
              if (header === "ClosingDate") {
                return (
                  <th key={header} className="refno">
                   Closing date
                  </th>
                );
              }

              if (header === "proposalStatus") {
                return (
                  <th key={header} className="refno">
                   Status
                  </th>
                );
              }
              if (header === "ViewIcon") {
                return (
                  <th key={header} className="refno">
                
                  </th>
                );
              }
            if (header === "proposalTitle") {
              return (
                <th key={header} className="refno">
                  Proposal Title
                </th>
              );
            }
            if (header === "proposalType") {
              return (
                <th key={header} className="proposalType">
                  Type
                </th>
              );
            }
            if (header === "status") {
              return (
                <th key={header} className="pstatus">
                  Status
                </th>
              );
            }
            if (header === "submissionDate") {
              return (
                <th
                  key={header}
                  className={`sortable-header ${isAscending ? "ascending" : ""}`}
                  onClick={(e) => handleSort(e)}
                >
                  Application date & time (CAT)
                </th>
              );
            }
            if (header === "channel") {
              return (
                <th key={header} className="channel">
                  Channel
                </th>
              );
            }
          })}
        </tr>
      </thead>
      <tbody>
        {props.data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {headers.map((header) => (
              <td key={header}>
                {row[header] !== null ? (
                  header === "CreatedBy" ? (
                    <>
                      <div>{row[header].Name}</div>
                      <div>{row[header].Role}</div>
                    </>
                   ) : header === "Status" ? (
                    <>
                      <div>{row[header].Status}</div>
                      <div>{row[header].StatusRemarks}</div>
                    </>
                  ) : header === "status" ? (
                    <div>
                      <img src={statusImg(row[header])} width={20} height={20} className="cursor" />
                      <button className={`status-button `} onClick={() => props.onRowClick(row)}>
                        {formatStatus(row[header])}
                      </button>
                    </div> 
                  ) : header === "submissionDate" ? (
                    <div>{formatDate(row[header])}</div> 
                  ) : header === "proposalType" ? (
                    <div>{proposols_type(row[header])}</div> 
                  ) :header === "ClosingDate" ? (
                    <div>{formatDate(row[header])}</div> 
                  ): header ==="ViewIcon" ?(
                    <div><img src={Globals.IMG.VIEW_ICON} width={20} height={20} className="ViewIcon"/></div> 
                  )
                  :(
                    row[header]
                  )
                ) : (
                  row[header]
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default NewTable;
